var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8001 1.2C11.1315 1.2 11.4001 1.46863 11.4001 1.8V3.006H0.600098V1.8C0.600098 1.46863 0.868727 1.2 1.2001 1.2H3.0001V0H4.2001V1.2H7.8001V0H9.0001V1.2H10.8001ZM10.8001 12H1.2001C0.868727 12 0.600098 11.7314 0.600098 11.4V4.206H11.4001V11.4C11.4001 11.7314 11.1315 12 10.8001 12ZM9.0001 6H7.8001V7.2H9.0001V6ZM7.8001 8.4H9.0001V9.6H7.8001V8.4ZM6.6001 6H5.4001V7.2H6.6001V6ZM5.4001 8.4H6.6001V9.6H5.4001V8.4ZM4.2001 6H3.0001V7.2H4.2001V6ZM3.0001 8.4H4.2001V9.6H3.0001V8.4Z",
    fill: "#C2C6D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.188701fb2ab675dd2b67773d9d5e0bdf.svg";
export { ForwardRef as ReactComponent };